// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac054dd4","453":"a27e06fb","732":"afe3a74d","977":"d9748528"}[chunkId] + ".chunk.js";
};